/**
 * UUID generation helper using Web Crypto API.
 * Generates v4 UUIDs for all database primary keys.
 */
export function generateId(): string {
  return crypto.randomUUID()
}
